module.exports = __webpack_public_path__ + "img/issued_tickets.70429f89.svg";